/**
 * COMPLETE HEARING TEST FILE WITH KLAVIYO INTEGRATION
 * 
 */

// ============================================================================
// PART 1: KLAVIYO FORM HANDLER (Step 1)
// ============================================================================

(function() {
  'use strict';

  /**
   * Send form data to Klaviyo
   */
  async function sendToKlaviyo(formData) {
    const PUBLIC_KEY = "QPBsHg";
    const LIST_ID = "UtRMJH"; // Hearing Test Participants - for consent

    const pursuits = [];
    if (formData.get("pursuit_preferences0")) pursuits.push("Waterfowl");
    if (formData.get("pursuit_preferences1")) pursuits.push("Turkey");
    if (formData.get("pursuit_preferences2")) pursuits.push("Deer");
    if (formData.get("pursuit_preferences3")) pursuits.push("Elk");
    if (formData.get("pursuit_preferences4")) pursuits.push("Upland");
    if (formData.get("pursuit_preferences5")) pursuits.push("Range");
    if (formData.get("pursuit_preferences6")) pursuits.push("Home");

    console.log("📤 Sending to Klaviyo (subscription + profile)...");

    // Subscribe to list for marketing consent + set properties for segmentation
    const response = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${PUBLIC_KEY}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "revision": "2024-07-15"
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: formData.get("email"),
                    first_name: formData.get("firstname"),
                    last_name: formData.get("lastname"),
                    phone_number: formData.get("phone"),
                    properties: {
                      pursuit_preferences: pursuits,
                      age: formData.get("age") || "",
                      gender: formData.get("gender") || "",
                      hearing_test_status: "started",
                      hearing_test_started_at: new Date().toISOString()
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: LIST_ID
                }
              }
            }
          }
        })
      }
    );

    console.log("📥 Klaviyo response status:", response.status);

    // Check response
    const text = await response.text();
    console.log("📥 Klaviyo response text:", text);

    if (response.ok || response.status === 202 || response.status === 201) {
      console.log("✅ Profile created/updated successfully");
      return { success: true };
    }

    console.error("❌ Klaviyo error:", response.status, text);
    throw new Error(`Klaviyo error: ${response.status} - ${text}`);
  }

  /**
   * Send form data to HubSpot Form 1 (Step 1)
   */
  function sendToHubSpotStep1(formData) {
    console.log("📤 Sending to HubSpot (Step 1)...");
    
    try {
      // Get HubSpot iframe and form
      var hsIframe = document.getElementById('hs-form-iframe-0');
      if (!hsIframe) {
        console.error("❌ HubSpot iframe not found");
        return false;
      }

      var hsDoc = hsIframe.contentWindow.document;
      var hsForm = hsDoc.getElementById("hsForm_949c98b0-32a1-4f81-b47a-3ac1c82256dd");
      
      if (!hsForm) {
        console.error("❌ HubSpot form not found in iframe");
        return false;
      }

      // Populate HubSpot form fields
      var hsFormEmail = hsDoc.getElementById("email-949c98b0-32a1-4f81-b47a-3ac1c82256dd");
      var hsFormFirstName = hsDoc.getElementById("firstname-949c98b0-32a1-4f81-b47a-3ac1c82256dd");
      var hsFormLastName = hsDoc.getElementById("lastname-949c98b0-32a1-4f81-b47a-3ac1c82256dd");
      var hsFormPhone = hsDoc.getElementById("phone-949c98b0-32a1-4f81-b47a-3ac1c82256dd");
      var hsFormAge = hsDoc.getElementById("age-949c98b0-32a1-4f81-b47a-3ac1c82256dd");
      var hsFormGender = hsDoc.getElementById("gender-949c98b0-32a1-4f81-b47a-3ac1c82256dd");
      var hsFormWaterFowl = hsDoc.getElementById("pursuit_preferences0-949c98b0-32a1-4f81-b47a-3ac1c82256dd");
      var hsFormTurkey = hsDoc.getElementById("pursuit_preferences1-949c98b0-32a1-4f81-b47a-3ac1c82256dd");
      var hsFormDeer = hsDoc.getElementById("pursuit_preferences2-949c98b0-32a1-4f81-b47a-3ac1c82256dd");
      var hsFormElk = hsDoc.getElementById("pursuit_preferences3-949c98b0-32a1-4f81-b47a-3ac1c82256dd");
      var hsFormUpland = hsDoc.getElementById("pursuit_preferences4-949c98b0-32a1-4f81-b47a-3ac1c82256dd");
      var hsFormClays = hsDoc.getElementById("pursuit_preferences5-949c98b0-32a1-4f81-b47a-3ac1c82256dd");
      var hsFormEveryDay = hsDoc.getElementById("pursuit_preferences6-949c98b0-32a1-4f81-b47a-3ac1c82256dd");

      if (hsFormEmail) hsFormEmail.value = formData.get("email");
      if (hsFormFirstName) hsFormFirstName.value = formData.get("firstname");
      if (hsFormLastName) hsFormLastName.value = formData.get("lastname");
      if (hsFormPhone) hsFormPhone.value = formData.get("phone");
      if (hsFormAge) hsFormAge.value = formData.get("age");
      if (hsFormGender) hsFormGender.value = formData.get("gender");
      if (hsFormWaterFowl) hsFormWaterFowl.checked = formData.get("pursuit_preferences0") !== null;
      if (hsFormTurkey) hsFormTurkey.checked = formData.get("pursuit_preferences1") !== null;
      if (hsFormDeer) hsFormDeer.checked = formData.get("pursuit_preferences2") !== null;
      if (hsFormElk) hsFormElk.checked = formData.get("pursuit_preferences3") !== null;
      if (hsFormUpland) hsFormUpland.checked = formData.get("pursuit_preferences4") !== null;
      if (hsFormClays) hsFormClays.checked = formData.get("pursuit_preferences5") !== null;
      if (hsFormEveryDay) hsFormEveryDay.checked = formData.get("pursuit_preferences6") !== null;

      // Also populate email field in Step 4 form for later
      var hs2FromEmail = document.getElementById("email-81610845-f4e1-4819-a626-54b6f4af0c4f");
      if (hs2FromEmail) {
        hs2FromEmail.value = formData.get("email");
      }

      // Submit the HubSpot form
      hsForm.submit();
      console.log("✅ HubSpot Step 1 submitted");
      return true;
      
    } catch (error) {
      console.error("❌ HubSpot Step 1 error:", error);
      return false;
    }
  }

  /**
   * Form submit handler
   */
  function htSignUpHandler(ev) {
    ev.preventDefault();
    ev.stopPropagation();

    var formData = new FormData(ev.target);
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!re.test(String(formData.get("email")).toLowerCase())) {
      var htFormEmail = document.getElementById("ht-email");
      var existingError = htFormEmail.parentNode.querySelector('.hs-error-msgs');
      if (existingError) existingError.remove();
      
      var errorDiv = document.createElement("div");
      errorDiv.classList.add("hs-error-msgs");
      errorDiv.style.cssText = "color: #d32f2f; margin-top: 5px; font-size: 14px;";
      var errorSpan = document.createElement("span");
      errorSpan.innerText = "Valid email address required.";
      errorDiv.appendChild(errorSpan);
      htFormEmail.parentNode.insertBefore(errorDiv, htFormEmail.nextSibling);
      return false;
    }

    const submitBtn = ev.target.querySelector('input[type="submit"]');
    const originalBtnText = submitBtn ? submitBtn.value : "";
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.value = "Submitting...";
    }

    sendToKlaviyo(formData)
      .then(function() {
        console.log("✅ Klaviyo submission complete");
        
        // Also send to HubSpot (don't wait for it, let it happen in parallel)
        sendToHubSpotStep1(formData);
        
        sessionStorage.setItem('ht_email', formData.get("email"));
        sessionStorage.setItem('ht_firstname', formData.get("firstname") || "");
        sessionStorage.setItem('ht_lastname', formData.get("lastname") || "");
        sessionStorage.setItem('ht_phone', formData.get("phone") || "");
        sessionStorage.setItem('ht_age', formData.get("age") || "");
        sessionStorage.setItem('ht_gender', formData.get("gender") || "");

        const pursuits = [];
        if (formData.get("pursuit_preferences0")) pursuits.push("Waterfowl");
        if (formData.get("pursuit_preferences1")) pursuits.push("Turkey");
        if (formData.get("pursuit_preferences2")) pursuits.push("Deer");
        if (formData.get("pursuit_preferences3")) pursuits.push("Elk");
        if (formData.get("pursuit_preferences4")) pursuits.push("Upland");
        if (formData.get("pursuit_preferences5")) pursuits.push("Range");
        if (formData.get("pursuit_preferences6")) pursuits.push("Home");
        sessionStorage.setItem('ht_pursuits', JSON.stringify(pursuits));

        var hearingTestContainer = document.getElementById("hearingTest");
        if (hearingTestContainer) {
          hearingTestContainer.classList.add("email-submitted", "show-controls");
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ "event": "htFormSubmitted", "formLocation": "step1" });
      })
      .catch(function(error) {
        console.error("Klaviyo error:", error);
        var htFormEmail = document.getElementById("ht-email");
        var existingError = htFormEmail.parentNode.querySelector('.hs-error-msgs');
        if (existingError) existingError.remove();
        
        var errorDiv = document.createElement("div");
        errorDiv.classList.add("hs-error-msgs");
        errorDiv.style.cssText = "color: #d32f2f; margin-top: 5px; font-size: 14px;";
        var errorSpan = document.createElement("span");
        errorSpan.innerText = "Something went wrong. Please try again.";
        errorDiv.appendChild(errorSpan);
        htFormEmail.parentNode.insertBefore(errorDiv, htFormEmail.nextSibling);

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.value = originalBtnText;
        }
      });

    return false;
  }

  /**
   * Initialize form handler
   */
  function init() {
    console.log("🔵 Form handler initializing...");
    const form = document.getElementById('ht-sign_up');
    
    if (!form) {
      console.error("❌ Form #ht-sign_up not found!");
      // Try again after a short delay
      setTimeout(init, 100);
      return;
    }
    
    console.log("✅ Form found, binding handler...");
    form.removeEventListener("submit", htSignUpHandler);
    form.addEventListener("submit", htSignUpHandler, true);
    window.htSignUpHandler = htSignUpHandler;
    console.log("✅ Form handler bound successfully!");
  }

  // Try multiple times to ensure the form is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Also try after a delay as backup
  setTimeout(init, 100);
})();


// ============================================================================
// PART 2: HEARING TEST CLASS
// ============================================================================

var HearingTest = (function() {
  
  function HearingTest(context) {
    this.context = context;
    this.selectors = {
      playButton: ".play-button",
      audioFiles: "[data-audio-files]",
      imageFiles: "[data-image-files]",
      page: ".hearing-test--page",
      pageTop: "pageTop",
      stepLabel: ".hearing-test--step--label",
      paginationBtn: ".pagination--button",
      paginationControl: ".pagination--controls--button",
      paginationPrev: ".pagination--controls--prev",
      paginationNext: ".pagination--controls--next",
      tabButton: ".tab--item--button",
      resultsSelector: ".results-grid--results",
      resultsContainer: ".hearing-test--results-grid--container",
      resultsGrid: "resultsGrid",
      resultsEmailBtn: ".results-grid--email-btn",
      resultsEmailDeets: ".results-grid--email-details",
      hsResultsContainer: ".hs_hearing_test_results___online",
      hsCategoryContainer: ".hs_hearing_test_results_category",
      htSignUpId: "ht-sign_up"
    };

    this.mode = "B";
    this.allHearingBands = [250, 375, 500, 750, 1000, 1500, 2000, 3000, 4000, 6000, 8000];
    this.allHearingDBHL = [-5, 0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80];
    this.tetraHearingBands = [500, 1000, 2000, 3000];
    this.tetraHearingDBHL = [-5, 0, 5, 10, 15, 20, 30, 40, 50, 60, 70, 80];
    this.printURL = null;
    this.backURL = null;
    this.overlay = 0;
    this.fileExt = ".mp3";
    this.fileSuffixForLRMode = "";
    this.fileNameArray = [];
    this.filesJSON = JSON.parse(document.querySelectorAll(this.selectors.audioFiles).item(0).innerHTML);
    this.imageJSON = JSON.parse(document.querySelectorAll(this.selectors.imageFiles).item(0).innerHTML);
    this.audioArray = [];
    this.allAudioButtons = [];
    this.resultMatrix = [];
    this.page = "1";
    this.pageId = { 1: "pageOne", 2: "pageTwo", 3: "pageThree", 4: "pageFour" };
    this.dBMarkers = { 1: "dB", 4: "0", 9: "10", 14: "20", 19: "30", 24: "40", 29: "50", 34: "60", 39: "70", 44: "80" };
    this.HzMarkers = { 2: "Hz", 5: "500", 10: "1000", 15: "2000", 19: "3000" };
    this.tabs = null;
    this.addresses = "info@tetrahearing.com";
    this.orderId = this._getOrderIdParam();
    this.validation = { "L": false, "R": false };
    this.htSignUpForm = document.getElementById(this.selectors.htSignUpId);
    
    this._init();
  }

  HearingTest.prototype._getOrderIdParam = function() {
    var url = window.location.href;
    var regex = new RegExp("[?&]orderId(=([^&#]*)|&|#|$)");
    var orderId = regex.exec(url);
    if (!orderId) return null;
    if (!orderId[2]) return "";
    return decodeURIComponent(orderId[2].replace(/\+/g, " "));
  };

  HearingTest.prototype.tableGen = function(opts) {
    var freqs = opts.freqs;
    var dBHLs = opts.dBHLs;
    var mode = opts.mode;
    var tableId = opts.tableId;
    var content = "<table class='hearing-test'>";
    content += "<tr>";
    content += "<td>&nbsp;</td>";
    content += "<td><div class='hearing-test--col-header'>1</div></td>";
    content += "<td><div class='hearing-test--col-header'>2</div></td>";
    content += "<td><div class='hearing-test--col-header'>3</div></td>";
    content += "<td><div class='hearing-test--col-header'>4</div></td>";
    content += "</tr>";
    
    for (var i = 0; i < dBHLs.length; i++) {
      content += "<tr>";
      if (dBHLs[i] === -5) content += "<td class='hearing-test--row-header' rowspan='2'><div><div class='hearing-test--sound-descr'>Almost Silent</div></div></td>";
      if (dBHLs[i] === 5) content += "<td class='hearing-test--row-header' rowspan='4'><div><div class='hearing-test--sound-descr'>Quiet</div></div></td>";
      if (dBHLs[i] === 30) content += "<td class='hearing-test--row-header' rowspan='4'><div><div class='hearing-test--sound-descr'>Louder</div></div></td>";
      if (dBHLs[i] === 70) content += "<td class='hearing-test--row-header' rowspan='2'><div><div class='hearing-test--sound-descr'>VERY LOUD</div></div></td>";
      
      for (var j = 0; j < freqs.length; j++) {
        var classes = null;
        if ([0, 20, 60, 80].includes(dBHLs[i])) classes = "bottom-spacer";
        if ([-5, 5, 30, 70].includes(dBHLs[i])) classes = "top-spacer";
        content += "<td>";
        content += "<div class='audio-button--container " + (classes || "") + "'>";
        content += "<svg class='t-icon t-icon-white' data-targetid='hearingTest.online.warble_" + freqs[j] + "_" + dBHLs[i] + "_" + mode + "'>";
        content += "<g><path d=\"M10.596,2.97v13.907c0,0.6-0.492,0.991-1,0.991c-0.243,0-0.492-0.089-0.694-0.289l-3.684-3.685H0.993C0.444,13.896,0,13.451,0,12.902V6.943C0,6.394,0.444,5.95,0.993,5.95h4.224L8.9,2.268c0.201-0.201,0.451-0.291,0.694-0.291 C10.104,1.976,10.596,2.37,10.596,2.97z M15.895,9.923c0,1.32-0.726,2.539-1.894,3.183c-0.481,0.264-1.085,0.094-1.353-0.391 c-0.263-0.48-0.09-1.084,0.393-1.351c0.535-0.294,0.866-0.847,0.866-1.441c0-0.594-0.331-1.146-0.866-1.44 c-0.482-0.266-0.655-0.87-0.393-1.349c0.265-0.48,0.871-0.654,1.353-0.392C15.169,7.384,15.895,8.604,15.895,9.923z M19.868,9.923 c0,2.612-1.325,5.013-3.548,6.425c-0.496,0.312-1.104,0.118-1.372-0.309c-0.296-0.463-0.157-1.077,0.306-1.369 c1.645-1.045,2.627-2.816,2.627-4.747c0-1.927-0.982-3.7-2.627-4.744c-0.463-0.293-0.602-0.906-0.306-1.372 c0.292-0.463,0.905-0.601,1.372-0.306C18.543,4.911,19.868,7.312,19.868,9.923z\" /> </g>";
        content += "</svg>";
        content += "<div class='play-button audio-button' id='hearingTest.online.warble_" + freqs[j] + "_" + dBHLs[i] + "_" + mode + "' data-mode='" + mode + "' data-file-name='hearingTest.online.warble_" + freqs[j] + "_" + dBHLs[i] + "_" + mode + "' title='Click to Play " + freqs[j] + "Hz@" + dBHLs[i] + "' data-gtm-event=\"hearing-test-interaction\">";
        content += "</div>";
        content += "</div>";
        content += "</td>";
      }
      content += "</tr>";
    }
    content += "</table>";
    document.getElementById(tableId).innerHTML = content;
    this._playButtonFactory();
  };

  HearingTest.prototype.genResultsGrid = function() {
    var content = "<table class='hearing-test--results-grid'>";
    for (var i = 0; i < 50; i++) {
      var rowClasses = "";
      if ([4, 9, 14, 19, 24, 29, 34, 39, 44].includes(i)) rowClasses += "border-bottom";
      if (i >= 20) rowClasses += " field-shaded";
      if (i >= 36) rowClasses += " clinical-shaded";
      content += "<tr>";
      
      for (var j = 0; j < 20; j++) {
        var colClasses = null;
        var containerId = null;
        var labelDiv = null;
        var sectionLabel = null;
        var areaDescript = null;
        var animalIcon = null;
        var adjustClass = "";
        var bracket = "";
        
        switch (j) {
          case 4: containerId = "Hz500"; break;
          case 9: containerId = "Hz1000"; break;
          case 14: containerId = "Hz2000"; break;
          case 19: containerId = "Hz3000"; break;
        }
        
        if (containerId) {
          var dB = "";
          switch (i) {
            case 3: dB = "-5"; adjustClass = "half-value"; break;
            case 5: dB = "0"; break;
            case 8: dB = "5"; adjustClass = "half-value"; break;
            case 10: dB = "10"; break;
            case 13: dB = "15"; break;
            case 15: dB = "20"; break;
            case 20: dB = "30"; break;
            case 25: dB = "40"; break;
            case 30: dB = "50"; break;
            case 35: dB = "60"; break;
            case 40: dB = "70"; break;
            case 45: dB = "80"; break;
          }
          containerId += "dB" + dB;
        }
        
        if ([4, 9, 14].includes(j)) colClasses = "border-right";
        if (j === 0 && this.dBMarkers[i] !== undefined) {
          labelDiv = "<div class=\"results-grid--label left\"><span>" + this.dBMarkers[i] + "</span></div>";
        }
        if (i === 0 && this.HzMarkers[j] !== undefined) {
          if (j === 19) {
            labelDiv = "<div class=\"results-grid--label top last\"><span>" + this.HzMarkers[j] + "</span></div>";
          } else {
            labelDiv = "<div class=\"results-grid--label top\"><span>" + this.HzMarkers[j] + "</span></div>";
          }
        }
        if (i === 9 && j === 0) sectionLabel = "<div class=\"results-grid--label--section\">Normal Hearing</div>";
        if (i === 34 && j === 0) sectionLabel = "<div class=\"results-grid--label--section\">Severe Hearing Loss</div>";
        
        if (i === 21 && j === 19) {
          areaDescript = "<div class=\"results-grid--area-descript clinical\">No, everyone is NOT mumbling... its your ears!</div>";
          areaDescript += "<div class=\"results-grid--area-descript field\"><strong>If your hearing levels are here:</strong><br />You can't hear or locate that gobble <br />Deer are sneaking up on you before you hear them</div>";
        }
        if (i === 32 && j === 19) {
          areaDescript = "<div class=\"results-grid--area-descript field\"><strong>If your hearing levels are here:</strong><br />You are the last gun shooting, since you didn't hear \"Take 'em\"<br />And you spook everything in the woods, since you cant hear how much noise you make walking</div>";
        }
        if (i === 31 && j === 19) {
          areaDescript = "<div class=\"results-grid--area-descript clinical\">Everyone who knows you, knows you struggle to hear.</div>";
        }
        if (i === 42 && j === 19) {
          areaDescript = "<div class=\"results-grid--area-descript clinical\">You will be surprised how much better life will be with TETRA.</div>";
        }
        
        if (i === 19 && j === 19) {
          bracket = "<div class=\"results-grid--bracket field top\"></div>";
          bracket += "<div class=\"results-grid--bracket clinical top\"></div>";
        }
        if (i === 25 && j === 19) bracket = "<div class=\"results-grid--bracket clinical bottom\"></div>";
        if (i === 29 && j === 19) {
          bracket = "<div class=\"results-grid--bracket clinical top\"></div>";
          bracket += "<div class=\"results-grid--bracket field bottom\"></div>";
        }
        if (i === 31 && j === 19) bracket = "<div class=\"results-grid--bracket field top\"></div>";
        if (i === 35 && j === 19) bracket = "<div class=\"results-grid--bracket clinical bottom\"></div>";
        if (i === 37 && j === 19) bracket = "<div class=\"results-grid--bracket clinical top\"></div>";
        if (i === 42 && j === 19) bracket = "<div class=\"results-grid--bracket field bottom\"></div>";
        if (i === 49 && j === 19) bracket = "<div class=\"results-grid--bracket clinical bottom\"></div>";
        
        if (i === 22 && j === 14) animalIcon = "<div class=\"results-grid--animal-icon\" style=\"top: -24px;\"><img src=\"" + this.imageJSON["icon-turkey-solid"] + "\"/></div>";
        if (i === 26 && j === 14) animalIcon = "<div class=\"results-grid--animal-icon\" style=\"top: -34px;\"><img src=\"" + this.imageJSON["icon-deer-solid"] + "\"/></div>";
        if (i === 29 && j === 14) animalIcon = "<div class=\"results-grid--animal-icon\" style=\"top: -32px;\"><img src=\"" + this.imageJSON["icon-duck-solid"] + "\"/></div>";
        if (i === 32 && j === 14) animalIcon = "<div class=\"results-grid--animal-icon\" style=\"top: -32px;\"><img src=\"" + this.imageJSON["icon-elk-solid"] + "\"/></div>";
        
        content += "<td class='results-grid--unit " + (colClasses || "") + " " + rowClasses + "'>";
        content += containerId ? "<div id='" + containerId + "' class='results-grid--unit--container " + adjustClass + "'>" : "<div class='results-grid--unit--container'>";
        if (labelDiv) content += labelDiv;
        if (sectionLabel) content += sectionLabel;
        if (areaDescript) content += areaDescript;
        if (animalIcon) content += animalIcon;
        if (bracket) content += bracket;
        content += "</div>";
        content += "</td>";
      }
      content += "</tr>";
    }
    content += "</table>";
    content += "<p style=\"margin: 0 auto; width: 300px\">";
    content += "<small>*GOBBLE, SNORT, HAIL, BUGLE AT 100 YARDS</small><br />";
    content += "<svg class=\"t-icon t-icon-sm t-icon-blue\"><use xlink:href=\"#icon-close\"></use></svg> <small>LEFT</small>    ";
    content += "&nbsp;&nbsp;<svg class=\"t-icon t-icon-sm t-icon-red\"><use xlink:href=\"#icon-donut\"></use></svg> <small>RIGHT</small>";
    content += "</p>";
    document.getElementById(this.selectors.resultsGrid).insertAdjacentHTML("afterbegin", content);
  };

  HearingTest.prototype.initResultMatrix = function() {
    for (var i = 0; i < this.tetraHearingBands.length; i++) {
      for (var j = 0; j < this.tetraHearingDBHL.length; j++) {
        this.resultMatrix["L"][this.tetraHearingBands[i]][this.tetraHearingDBHL[j]] = 0;
        this.resultMatrix["R"][this.tetraHearingBands[i]][this.tetraHearingDBHL[j]] = 0;
      }
    }
  };

  HearingTest.prototype.updateResultMatrix = function(soundFile, mode) {
    var tmp = soundFile.split("_");
    var x = tmp[1];
    var y = tmp[2];
    document.getElementById(tmp[0] + "_" + tmp[1] + "_" + tmp[2] + "_" + tmp[3]).parentNode.classList.add("selected");
    for (var j = 0; j < this.tetraHearingDBHL.length; j++) {
      this.resultMatrix[mode][x][this.tetraHearingDBHL[j]] = 0;
    }
    this.resultMatrix[mode][x][y] = 1;
  };

  HearingTest.prototype.clearTable = function() {
    for (var i = 0; i < this.allHearingBands.length; i++) {
      document.getElementById("overB" + this.allHearingBands[i]).innerHTML = "";
      document.getElementById("overL" + this.allHearingBands[i]).innerHTML = "";
      document.getElementById("overR" + this.allHearingBands[i]).innerHTML = "";
    }
    this.initResultMatrix();
  };

  HearingTest.prototype.getUrlVars = function() {
    var vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
      vars[key] = value;
    });
    return vars;
  };

  HearingTest.prototype._clearResultMatrix = function() {
    var results = Array.from(document.querySelectorAll(this.selectors.resultsSelector));
    results.forEach(function(el) {
      el.parentNode.removeChild(el);
    });
  };

  HearingTest.prototype._plotResultMatrix = function() {
    var _this = this;
    var modes = ["L", "R"];
    var hsDataInputField = document.querySelectorAll(this.selectors.hsResultsContainer).item(0).querySelectorAll("[name=\"hearing_test_results___online\"]").item(0);
    var hsCategoryInputField = document.querySelectorAll(this.selectors.hsCategoryContainer).item(0).querySelectorAll("[name=\"hearing_test_results_category\"]").item(0);
    
    modes.forEach(function(mode) {
      var hsHearingCategory = "standard";
      for (var i = 0; i < _this.tetraHearingBands.length; i++) {
        for (var j = 0; j < _this.tetraHearingDBHL.length; j++) {
          if (_this.resultMatrix[mode][_this.tetraHearingBands[i]][_this.tetraHearingDBHL[j]] !== 0) {
            var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            var use = document.createElementNS("http://www.w3.org/2000/svg", "use");
            switch (mode) {
              case "L":
                svg.setAttribute("class", "t-icon t-icon-blue");
                use.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#icon-close");
                break;
              case "R":
                svg.setAttribute("class", "t-icon t-icon-red");
                use.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#icon-donut");
                break;
            }
            hsDataInputField.value += mode + ": " + _this.tetraHearingBands[i] + "Hz " + _this.tetraHearingDBHL[j] + "dB \n";
            if (_this.tetraHearingDBHL[j] >= 30) {
              hsHearingCategory = "loss";
            }
            svg.appendChild(use);
            var resultsContainer = document.getElementById("Hz" + _this.tetraHearingBands[i] + "dB" + _this.tetraHearingDBHL[j]);
            if (!resultsContainer) continue;
            var div = document.createElement("div");
            div.classList.add("results-grid--results");
            div.appendChild(svg);
            resultsContainer.appendChild(div);
          }
        }
      }
      hsCategoryInputField.value = hsHearingCategory;
    });
  };

  HearingTest.prototype._checkCompleted = function(mode) {
    var tot = 0;
    for (var i = 0; i < this.tetraHearingBands.length; i++) {
      for (var j = 0; j < this.tetraHearingDBHL.length; j++) {
        tot += this.resultMatrix[mode][this.tetraHearingBands[i]][this.tetraHearingDBHL[j]];
      }
    }
    if (tot === 4) {
      this.validation[mode] = true;
      this._setNextControlState();
      this._setPaginationState();
    }
  };

  HearingTest.prototype.checkAudioFileCompatibility = function() {
    var a = document.createElement("audio");
    if (!!(a.canPlayType && a.canPlayType("audio/ogg; codecs=\"vorbis\"").replace(/no/, "")))
      this.fileExt = ".ogg";
  };

  HearingTest.prototype.play = function(el) {
    var mode = el.getAttribute("data-mode");
    var soundFile = el.getAttribute("data-file-name");
    var fileIndex = soundFile.replace("hearingTest.online.", "") + this.fileExt;
    var soundFileUrl = this.filesJSON[fileIndex];
    var i = this.fileNameArray.indexOf(soundFile);
    if (mode) {
      this.clearLast(soundFile);
    }
    for (var k = 0; k < this.audioArray.length; k++) {
      if (k !== i && !isNaN(this.audioArray[k].duration)) {
        this.audioArray[k].pause();
        this.audioArray[k].currentTime = 0;
      }
    }
    if (i === -1) {
      el.parentNode.classList.add("loading");
      this.fileNameArray.push(soundFile);
      i = this.fileNameArray.indexOf(soundFile);
      this.audioArray[i] = new Audio(soundFileUrl);
      this.audioArray[i].onplay = function() {
        el.parentNode.classList.remove("loading");
        el.parentNode.classList.remove("pause");
        el.parentNode.classList.add("playing");
      };
      this.audioArray[i].onpause = function() {
        el.parentNode.classList.remove("playing");
        el.parentNode.classList.add("pause");
      };
      this.audioArray[i].onended = function() {
        el.parentNode.classList.remove("playing");
        el.parentNode.classList.remove("pause");
      };
      this.audioArray[i].loop = 0;
      this.audioArray[i].volume = 1;
      this.audioArray[i].play();
    } else {
      if (this.audioArray[i].readyState === 0) {
        el.parentNode.classList.remove("loading");
      } else {
        this.audioArray[i].onplay = function() {
          el.parentNode.classList.remove("loading");
          el.parentNode.classList.remove("pause");
          el.parentNode.classList.add("playing");
        };
        if (this.audioArray[i].paused) {
          this.audioArray[i].play();
        } else {
          this.audioArray[i].pause();
        }
      }
    }
    if (mode) {
      this.updateResultMatrix(soundFile, mode);
      this._checkCompleted(mode);
    }
  };

  HearingTest.prototype._handlePlayEvent = function(ev) {
    ev.preventDefault();
    this.play(ev.target);
  };

  HearingTest.prototype._bindPlayEvent = function(el) {
    el.addEventListener("click", this._handlePlayEvent.bind(this));
    el.addEventListener("touchstart", this._handlePlayEvent.bind(this));
    return el;
  };

  HearingTest.prototype._playButtonFactory = function() {
    var _this = this;
    var playButtons = Array.from(document.querySelectorAll(this.selectors.playButton));
    return playButtons.map(function(el) {
      var instanceKey = "data-play-button-instance";
      var cachePlayButton = el.getAttribute(instanceKey);
      if (cachePlayButton) {
        return cachePlayButton;
      }
      var playButton = _this._bindPlayEvent(el);
      el.setAttribute(instanceKey, playButton);
      return playButton;
    });
  };

  HearingTest.prototype.clearLast = function(soundFile) {
    var tmp = soundFile.split("_");
    for (var k = 0; k < this.tetraHearingDBHL.length; k++) {
      document.getElementById(tmp[0] + "_" + tmp[1] + "_" + this.tetraHearingDBHL[k] + "_" + tmp[3]).parentNode.classList.remove("selected");
    }
  };

  HearingTest.prototype._resetPaginationInterface = function() {
    var _this = this;
    var prev = document.querySelectorAll(this.selectors.paginationPrev).item(0);
    var next = document.querySelectorAll(this.selectors.paginationNext).item(0);
    var paginationButtons = Array.from(document.querySelectorAll(this.selectors.paginationBtn));
    var paginationLabel = document.querySelectorAll(this.selectors.stepLabel).item(0);
    
    paginationButtons.forEach(function(el) {
      if (el.getAttribute("data-page") === _this.page) {
        el.parentNode.classList.add("active");
      } else {
        el.parentNode.classList.remove("active");
      }
    });
    
    prev.setAttribute("data-page", parseInt(this.page) - 1);
    next.setAttribute("data-page", parseInt(this.page) + 1);
    
    if (prev.getAttribute("data-page") < 1) {
      prev.disabled = true;
    } else {
      prev.disabled = false;
    }
    
    this._setNextControlState();
    paginationLabel.innerText = this.page;
  };

  HearingTest.prototype._setNextControlState = function() {
    var nextEl = document.querySelectorAll(this.selectors.paginationNext).item(0);
    
    // Page 1 is instructions - always allow
    if (this.page === "1") {
      nextEl.disabled = false;
    }
    // Page 2 is right ear - require validation
    else if (this.page === "2" && !this.validation["R"]) {
      nextEl.disabled = true;
    }
    // Page 3 is left ear - require validation
    else if (this.page === "3" && !this.validation["L"]) {
      nextEl.disabled = true;
    }
    // Page 4 is results - no next button
    else if (this.page === "4") {
      nextEl.disabled = true;
    }
    // All other cases
    else {
      nextEl.disabled = false;
    }
  };

  HearingTest.prototype._setPaginationState = function() {
    var paginationBtns = Array.from(document.querySelectorAll(this.selectors.paginationBtn));
    if (this.page === "2" && this.validation["R"]) {
      paginationBtns[2].classList.remove("disabled");
    }
    if (this.page === "3" && this.validation["L"]) {
      paginationBtns[3].classList.remove("disabled");
    }
  };

  HearingTest.prototype._switchActivePage = function() {
    var pages = Array.from(document.querySelectorAll(this.selectors.page));
    var activePage = document.getElementById(this.pageId[this.page]);
    var pageTopAnchor = document.getElementById(this.selectors.pageTop);
    pages.forEach(function(el) {
      el.classList.remove("active");
    });
    activePage.classList.add("active");
    pageTopAnchor.scrollIntoView();
    this._setNextControlState();
  };

  HearingTest.prototype._handlePaginationEvent = function(ev) {
    var el = ev.target;
    if (el.classList.contains("disabled")) {
      return;
    }
    this.page = el.getAttribute("data-page") ? el.getAttribute("data-page") : el.parentNode.getAttribute("data-page");
    this._switchActivePage();
    this._resetPaginationInterface();
    
    switch (this.page) {
      case "1":
        window.dataLayer.push({ "event": "htStep1" });
        break;
      case "2":
        window.dataLayer.push({ "event": "htStep2" });
        break;
      case "3":
        window.dataLayer.push({ "event": "htStep3" });
        break;
      case "4":
        window.dataLayer.push({ "event": "htStep4" });
        this._clearResultMatrix();
        this._resetHubSpotInputField();
        this._plotResultMatrix();
        
        // KLAVIYO INTEGRATION - Send to Klaviyo instead of HubSpot
        this._sendResultsToKlaviyo();
        
        break;
    }
  };

  HearingTest.prototype._bindPaginationEvent = function(el) {
    el.addEventListener("click", this._handlePaginationEvent.bind(this));
    el.addEventListener("touchstart", this._handlePaginationEvent.bind(this));
    return el;
  };

  HearingTest.prototype._paginationButtonFactory = function() {
    var _this = this;
    var pagButtons = Array.from(document.querySelectorAll(this.selectors.paginationBtn));
    return pagButtons.map(function(el) {
      var instanceKey = "data-pagination-button-instance";
      var cachePagButton = el.getAttribute(instanceKey);
      if (cachePagButton) {
        return cachePagButton;
      }
      var pagButton = _this._bindPaginationEvent(el);
      el.setAttribute(instanceKey, pagButton);
      return pagButton;
    });
  };

  HearingTest.prototype._paginationControlFactory = function() {
    var _this = this;
    var pagControls = Array.from(document.querySelectorAll(this.selectors.paginationControl));
    return pagControls.map(function(el) {
      var instanceKey = "data-pagination-control-instance";
      var cacheControlButton = el.getAttribute(instanceKey);
      if (cacheControlButton) {
        return cacheControlButton;
      }
      var controlButton = _this._bindPaginationEvent(el);
      el.setAttribute(instanceKey, controlButton);
      return controlButton;
    });
  };

  HearingTest.prototype._resetHubSpotInputField = function() {
    document.querySelectorAll(this.selectors.hsResultsContainer).item(0).querySelectorAll("[name=\"hearing_test_results___online\"]").item(0).value = "";
    document.querySelectorAll(this.selectors.hsCategoryContainer).item(0).querySelectorAll("[name=\"hearing_test_results_category\"]").item(0).value = "";
  };

  HearingTest.prototype._handleTabEvent = function(ev) {
    ev.preventDefault();
    var el = ev.target.getAttribute("data-tab") ? ev.target : ev.target.parentNode;
    var container = document.querySelectorAll(this.selectors.resultsContainer).item(0);
    container.classList.remove("field-view");
    container.classList.remove("clinical-view");
    container.classList.add(el.getAttribute("data-tab"));
    this.tabs.forEach(function(el) {
      el.classList.remove("active");
    });
    el.classList.add("active");
  };

  HearingTest.prototype._bindTabEvent = function(el) {
    el.addEventListener("click", this._handleTabEvent.bind(this));
    el.addEventListener("touchstart", this._handleTabEvent.bind(this));
    return el;
  };

  HearingTest.prototype._tabFactory = function() {
    var _this = this;
    var tabButton = Array.from(document.querySelectorAll(this.selectors.tabButton));
    return tabButton.map(function(el) {
      var instanceKey = "data-tab-button";
      var cacheTabButton = el.getAttribute(instanceKey);
      if (cacheTabButton) {
        return cacheTabButton;
      }
      var tabButton = _this._bindTabEvent(el);
      el.setAttribute(instanceKey, tabButton);
      return tabButton;
    });
  };

  // ============================================================================
  // PART 3: KLAVIYO STEP 4 METHODS
  // ============================================================================

  /**
   * Send completed results to Klaviyo
   */
  HearingTest.prototype._sendResultsToKlaviyo = function() {
    const PUBLIC_KEY = "QPBsHg";
    const email = sessionStorage.getItem('ht_email');
    const firstname = sessionStorage.getItem('ht_firstname');
    const lastname = sessionStorage.getItem('ht_lastname');

    console.log("📤 [STEP 4] Starting Klaviyo submission...");
    console.log("📧 Email from session:", email);

    if (!email) {
      console.error("❌ No email in session storage");
      return;
    }

    const hsDataInputField = document.querySelectorAll(this.selectors.hsResultsContainer)
      .item(0).querySelectorAll("[name=\"hearing_test_results___online\"]").item(0);
    
    const hsCategoryInputField = document.querySelectorAll(this.selectors.hsCategoryContainer)
      .item(0).querySelectorAll("[name=\"hearing_test_results_category\"]").item(0);
    
    const results = hsDataInputField ? hsDataInputField.value : "";
    const category = hsCategoryInputField ? hsCategoryInputField.value : "standard";

    console.log("📊 Results:", results);
    console.log("📊 Category:", category);

    if (!results) {
      console.error("❌ No results data");
      return;
    }

    const payload = {
      data: {
        type: "profile",
        attributes: {
          email: email,
          properties: {
            hearing_test_results: results,
            hearing_test_category: category,
            hearing_test_status: "completed",
            hearing_test_completed_at: new Date().toISOString()
          }
        }
      }
    };

    console.log("📤 Sending profile update to Klaviyo:", JSON.stringify(payload, null, 2));

    fetch(`https://a.klaviyo.com/client/profiles/?company_id=${PUBLIC_KEY}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "revision": "2024-07-15"
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      console.log("📥 Profile update response status:", response.status);
      return response.text().then(text => ({ status: response.status, text: text }));
    })
    .then(({ status, text }) => {
      console.log("📥 Profile update response text:", text);
      
      if (status === 200 || status === 201 || status === 202) {
        console.log("✅ Profile update successful");
        this._triggerTeamNotification(email, firstname, lastname, results, category);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ "event": "htCompleted", "hearingCategory": category });
        this._showCompletionMessage();
      } else {
        console.error("❌ Profile update failed with status:", status);
        console.error("❌ Response:", text);
      }
    })
    .catch(error => {
      console.error("❌ Klaviyo profile update error:", error);
      this._showCompletionMessage();
    });
  };

  /**
   * Trigger team notification event
   */
  HearingTest.prototype._triggerTeamNotification = function(email, firstname, lastname, results, category) {
    const PUBLIC_KEY = "QPBsHg";

    console.log("📤 [STEP 4] Triggering team notification event...");

    const eventPayload = {
      data: {
        type: "event",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: { email: email }
            }
          },
          metric: {
            data: {
              type: "metric",
              attributes: { name: "Hearing Test Completed" }
            }
          },
          properties: {
            customer_name: `${firstname} ${lastname}`,
            customer_email: email,
            test_results: results,
            test_category: category,
            completed_at: new Date().toISOString()
          },
          time: new Date().toISOString()
        }
      }
    };

    console.log("📤 Event payload:", JSON.stringify(eventPayload, null, 2));

    fetch(`https://a.klaviyo.com/client/events/?company_id=${PUBLIC_KEY}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "revision": "2024-07-15"
      },
      body: JSON.stringify(eventPayload)
    })
    .then(response => {
      console.log("📥 Event response status:", response.status);
      return response.text().then(text => ({ status: response.status, text: text }));
    })
    .then(({ status, text }) => {
      console.log("📥 Event response text:", text);
      if (status === 200 || status === 201 || status === 202) {
        console.log("✅ Team notification sent:", status);
      } else {
        console.error("❌ Team notification failed:", status, text);
      }
    })
    .catch(error => {
      console.error("❌ Team notification error:", error);
    });

    // Also submit to HubSpot Form 2
    this._sendResultsToHubSpot();
  };

  /**
   * Send completed results to HubSpot Form 2 (Step 4)
   */
  HearingTest.prototype._sendResultsToHubSpot = function() {
    console.log("📤 [STEP 4] Sending to HubSpot Form 2...");
    
    try {
      var hsForm = document.getElementById("hsForm_81610845-f4e1-4819-a626-54b6f4af0c4f");
      
      if (!hsForm) {
        console.error("❌ HubSpot Form 2 not found");
        return false;
      }

      // Form fields are already populated by the plotResultMatrix method
      // Just submit the form
      hsForm.submit();
      console.log("✅ HubSpot Step 4 submitted");
      return true;
      
    } catch (error) {
      console.error("❌ HubSpot Step 4 error:", error);
      return false;
    }
  };

  /**
   * Show completion message
   */
  HearingTest.prototype._showCompletionMessage = function() {
    const resultsContainer = document.querySelector('.hearing-test--results-grid--container');
    if (!resultsContainer) return;
    
    if (resultsContainer.querySelector('.hearing-test-completion-message')) return;
    
    const messageDiv = document.createElement('div');
    messageDiv.className = 'hearing-test-completion-message';
    messageDiv.style.cssText = 'background: #4CAF50; color: white; padding: 20px; margin: 20px 0; border-radius: 8px; text-align: center;';
    messageDiv.innerHTML = `
      <h3 style="margin: 0 0 10px 0;">✓ Test Completed!</h3>
      <p style="margin: 0;">Your results have been submitted. Our team will review them and contact you shortly.</p>
    `;
    
    resultsContainer.insertBefore(messageDiv, resultsContainer.firstChild);
  };

  // ============================================================================
  // INITIALIZATION
  // ============================================================================

  HearingTest.prototype._init = function() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "event": "htStep1" });

    // Form handler is already bound by the IIFE above
    // this.htSignUpForm.addEventListener("submit", window.htSignUpHandler);

    this.resultMatrix["B"] = [];
    this.resultMatrix["R"] = [];
    this.resultMatrix["L"] = [];
    
    for (var i = 0; i < this.allHearingBands.length; i++) {
      this.resultMatrix["B"][this.allHearingBands[i]] = [];
      this.resultMatrix["L"][this.allHearingBands[i]] = [];
      this.resultMatrix["R"][this.allHearingBands[i]] = [];
    }
    
    this.initResultMatrix();
    this.checkAudioFileCompatibility();
    this.tableGen({
      freqs: this.tetraHearingBands,
      dBHLs: this.tetraHearingDBHL,
      mode: "L",
      tableId: "leftEar"
    });
    this.tableGen({
      freqs: this.tetraHearingBands,
      dBHLs: this.tetraHearingDBHL,
      mode: "R",
      tableId: "rightEar"
    });
    this.genResultsGrid();
    this._paginationButtonFactory();
    this._paginationControlFactory();
    this.tabs = this._tabFactory();
  };

  return HearingTest;
})();


// ============================================================================
// INITIALIZE HEARING TEST
// ============================================================================

var hearingTest = document.getElementById("hearingTest");
if (hearingTest) {
  window.hearingTest = new HearingTest();
}